import { css, StyleSheet } from 'aphrodite/no-important';
import * as React from 'react';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import {
  MenuLinkThemeProps,
} from '../../components/navigation/header/primaryHeader/menu/links/MenuLink';
import { useTheme } from '../../../theming/useTheme';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../partials/link/TextLink';
import {
  Link, MenuLinkDataProps,
  MenuSubLink,
} from '../../components/navigation/header/primaryHeader/menu/links/MenuSubLink';
import { ChevronIcon, Directions } from '../../components/navigation/header/ChevronIcon';
import { H4, semanticCSS } from '../../../typography/semanticTags';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { NavigationLink } from '../../components/navigation/header/primaryHeader/PrimaryHeader';

/* eslint-disable react/no-unknown-property */

const componentConfigThemeKey = 'menuLink';

interface LinkDataProps {
    link: Link;
    childrenLinks: NavigationLink[] | null;
}

const getAmpSideBarLinkStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`,
    },
  },
  title: {
    backgroundColor: 'inherit',
    border: 'inherit',
    paddingRight: 0,
    ':focus': {
      outline: 'none',
    },
  },
  titleAndChevronIconWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const createAmpSideBarSubLink = (linkData: MenuLinkDataProps, index: number) => {
  const { link } = linkData;
  return <MenuSubLink text={link.text} href={link.href} key={index} />;
};

export const AMPSideBarLink: React.FunctionComponent<MenuLinkDataProps> = props => {
  const { idleColor, baseUnit } = useTheme<MenuLinkThemeProps>(componentConfigThemeKey);
  const { link, childrenLinks } = props;
  const style = getAmpSideBarLinkStyle(baseUnit);
  const linkStyle = generateLinkStyleFromTheme({ idleColor });

  return (
    <section className={css(style.wrapper)}>
      <H4 styles={semanticCSS(style.title)}>
        <div className={css(style.titleAndChevronIconWrapper)}>
          <TextLinkComponent href={link.href} linkStyle={linkStyle}>{link.text}</TextLinkComponent>
          {childrenLinks && childrenLinks.length > 0 ? <ChevronIcon direction={Directions.DOWN} color={idleColor} /> : null}
        </div>
      </H4>
      <ul>
        {childrenLinks && childrenLinks.map(createAmpSideBarSubLink)}
      </ul>
    </section>
  );
};
